import styled from 'styled-components';
import { Box } from 'src/viewLayer/components/DesignSystem';
import type { BabbelTheme } from '@lessonnine/design-tokens.lib/dist/json/theme';

export const AppContainer = styled(Box)`
  background-color: ${({ theme }: { theme: BabbelTheme }): string =>
    theme.color.neutral.surfaceDefault};
`;
